import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { resetChest } from '../../../../../../redux';
import { Button } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiLockReset } from '@mdi/js';

const ResetChestButton = ({ collector }) => {
    const { t }           = useTranslation();
    const dispatch        = useDispatch();

    const autotestCollector = () => {
        dispatch(resetChest(collector.id));
    }

    return (
        <Button className="operation" color="danger" block onClick={ autotestCollector }>
            <div className="icon">
                <Icon path={ mdiLockReset } size={ 3 } color="#FFFFFF" />{ ' ' }
            </div>
            <div className="title">
                { t('collectors.reset_chest') }
                <div className="subtitle">{ t('collectors.reset_chest_desc') }</div>
            </div>
        </Button>
    );
}

export default ResetChestButton;
